/* Angular */
import { createReducer, on } from '@ngrx/store';

/* Functions */
import { updateEntityInArray } from 'src/app/features/shared/functions';

/* actions */
import * as PharmacyDataStoreActions from './pharmacy-data-store.actions';

import { Pharmacy } from 'src/app/features/shared/models';

/* State key */
export const featureKey = 'PharmacyDataStore';

/* State interface */
export interface PharmacyState {
  isLoading?: boolean;
  pharmacies?: Pharmacy[];
  activePharmacy?: Pharmacy;
}

/* Initial values */
export const initialState: PharmacyState = {
  isLoading: null,
  pharmacies: null,
  activePharmacy: null,
};

export const reducer = createReducer(
  initialState,
  on(PharmacyDataStoreActions.GetPharmacies, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(PharmacyDataStoreActions.GetPharmaciesSuccessful, (state, action) => ({
    ...state,
    pharmacies: action.payload.pharmacies,
    isLoading: false,
  })),

  on(PharmacyDataStoreActions.GetPharmaciesFailure, (state, action) => ({
    ...state,
    isLoading: false,
  })),

  on(PharmacyDataStoreActions.GetPharmacyById, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(PharmacyDataStoreActions.GetPharmacyByIdSuccessful, (state, action) => ({
    ...state,
    /* TODO: replace item by id from data array */
    isLoading: false,
  })),

  on(PharmacyDataStoreActions.GetPharmacyByIdFailure, (state, action) => ({
    ...state,
    isLoading: false,
  })),

  on(PharmacyDataStoreActions.CreatePharmacy, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(PharmacyDataStoreActions.CreatePharmacySuccessful, (state, action) => ({
    ...state,
    pharmacies: [...(state.pharmacies ?? []), action.payload.pharmacy],
    isLoading: false,
  })),

  on(PharmacyDataStoreActions.CreatePharmacyFailure, (state, action) => ({
    ...state,
    isLoading: false,
  })),

  on(PharmacyDataStoreActions.UpdatePharmacy, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(PharmacyDataStoreActions.UpdatePharmacySuccessful, (state, action) => ({
    ...state,
    pharmacies: updateEntityInArray<Pharmacy>(
      action.payload.id,
      action.payload.data,
      state.pharmacies ?? [],
    ),
    isLoading: false,
  })),

  on(PharmacyDataStoreActions.UpdatePharmacyFailure, (state, action) => ({
    ...state,
    isLoading: false,
  })),

  on(PharmacyDataStoreActions.DeletePharmacy, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(PharmacyDataStoreActions.DeletePharmacySuccessful, (state, action) => ({
    ...state,
    pharmacies:
      state.pharmacies?.filter((item) => action.payload.id !== item.id) ?? [],
    isLoading: false,
  })),

  on(PharmacyDataStoreActions.DeletePharmacyFailure, (state, action) => ({
    ...state,
    isLoading: false,
  })),

  on(PharmacyDataStoreActions.ResetState, () => initialState),
);
